import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CATEGORY_OPTIONS = [
  { value: 'all', label: '全部分类' },
  { value: 'video', label: '免费视频' },
  { value: 'software', label: '免费软件' },
  { value: 'tutorial', label: '实用教程' },
];

interface SearchBarProps {
  initialKeyword?: string;
  initialCategory?: string;
  size?: 'md' | 'lg';
  placeholder?: string;
}

export default function SearchBar({
  initialKeyword = '',
  initialCategory = 'all',
  size = 'md',
  placeholder = '输入关键词，如「Python」「播放器」「纪录片」',
}: SearchBarProps) {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState(initialKeyword);
  const [category, setCategory] = useState(initialCategory);

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const params = new URLSearchParams();
    const value = keyword.trim();
    if (value) params.set('q', value);
    if (category && category !== 'all') params.set('type', category);
    navigate(`/search?${params.toString()}`);
  };

  const isLarge = size === 'lg';

  return (
    <form
      onSubmit={submit}
      className={`w-full flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-1.5 bg-background-50 border border-background-200 rounded-lg sm:rounded-full ${
        isLarge ? 'p-2 sm:pl-4' : 'p-1.5 sm:pl-3'
      } focus-within:border-primary-300 transition-colors`}
    >
      <div className="relative flex items-center">
        <select
          value={category}
          onChange={(event) => setCategory(event.target.value)}
          className={`appearance-none bg-background-100 rounded-md font-medium text-foreground-800 outline-none cursor-pointer pr-8 ${
            isLarge ? 'h-11 pl-3 text-sm' : 'h-9 pl-3 text-sm'
          }`}
        >
          {CATEGORY_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-2.5 w-4 h-4 flex items-center justify-center text-foreground-500">
          <i className="ri-arrow-down-s-line"></i>
        </span>
      </div>

      <div className={`flex-1 flex items-center gap-2 ${isLarge ? 'h-11' : 'h-10'} px-3`}>
        <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
          <i className="ri-search-line"></i>
        </span>
        <input
          type="text"
          value={keyword}
          onChange={(event) => setKeyword(event.target.value)}
          placeholder={placeholder}
          className={`flex-1 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${
            isLarge ? 'text-base' : 'text-sm'
          }`}
        />
      </div>

      <button
        type="submit"
        className={`shrink-0 rounded-md sm:rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium flex items-center justify-center gap-1.5 transition-colors cursor-pointer whitespace-nowrap ${
          isLarge ? 'h-11 px-6' : 'h-10 px-5'
        }`}
      >
        <i className="ri-search-line"></i>
        搜索
      </button>
    </form>
  );
}